import React from "react";
import { useNavigate } from "react-router-dom";
import { MarketFlowerItemPreview } from "./MarketFlowerListStyle";
import CloseBtnSvg from "assets/icons/closeBtn.svg";

const MarketFlowerPreview = () => {
  const navigate = useNavigate();
  const imageUrl = localStorage.getItem("floway-flower-preview");
  return (
    <MarketFlowerItemPreview>
      <button
        onClick={() => {
          localStorage.removeItem("floway-flower-preview");
          navigate(-1);
        }}
      >
        <img src={CloseBtnSvg} alt="close button" />
      </button>
      <img src={imageUrl} alt="flower" />
    </MarketFlowerItemPreview>
  );
};

export default MarketFlowerPreview;
